import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ConcreteCalculatorParams, concreteCalculatorService } from "@WhiteCap/Services/ConcreteCalculatorService"


type HandlerType = CustomApiHandler<ConcreteCalculatorParams & HasOnSuccess, { successful: boolean }>

export const BeginLoadCalculation: HandlerType = props => {
	props.dispatch({
		type: "Custom/ConcreteQuote/BeginLoadCalculation",
	});
};

export const LoadQuouteForConcreteCalculation: HandlerType = async (props) => {
	try {
		props.apiResult = await concreteCalculatorService({
			name: props.parameter.name,
			company_name: props.parameter.companyName,
			email: props.parameter.emailAddress,
			phone: props.parameter.phone,
			message: props.parameter.message,
			rfq_pdf: props.parameter.pdfBlob
		})
	} catch (error) {
		console.error('Error submitting quote:', error);
	}
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
	if (props.apiResult.successful) {
		props.parameter.onSuccess?.();
	}
};

export const CompleteLoadCalculation: HandlerType = props => {
	props.dispatch({
		type: "Custom/ConcreteQuote/CompleteLoadCalculation",
	});
};



export const chain = [BeginLoadCalculation, LoadQuouteForConcreteCalculation, ExecuteOnSuccessCallback, CompleteLoadCalculation];

const concreteCalculationQuoteHandler = createHandlerChainRunner(chain, "concreteCalculationQuoteHandler");
export default concreteCalculationQuoteHandler;